/**
 * slider using slickjs
 * @link https://kenwheeler.github.io/slick/
 */

jQuery(document).ready(function () {




		var controller = new ScrollMagic.Controller();


		//if(document.getElementsByClassName('components-explore-split').length > 0){

			$(".animate").each(function (index, elem) {

			var headerText = new TimelineLite();

			headerText.fromTo(elem, 1.5, { opacity: 0, y: 15 }, { opacity: 1, y: 0, ease: Power2.easeOut},  0.2);

			new ScrollMagic.Scene({triggerElement: elem}).setTween(headerText)

			.offset(-450)
			.reverse(false)
			.addTo(controller);

			});

		//};




});
